module.exports = __webpack_public_path__ + "static/media/Edit-icon-black.90fa8ead.svg";